module.exports = __webpack_public_path__ + "img/Arcr_logo.23ae68ea.svg";